import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/admin-management-panel/components/AdminPanelShell.tsx");
